<template>
    <!-- DO NOT MAKE ANY EDITS TO THIS TEMPLATE -->
  <div v-if="!error" class="apm-bank-transfer">
    <div v-loading="loading" class="app-container flex-container direction-row">
      <div class="flex-item width-grow">
        <div class="stripe flex-container direction-column">
          <div class="flex-container spacing-0 direction-column">
            <div class="flex-item width-grow">
              <div class="flex-container spacing-16 direction-column">
                <div class="flex-item width-grow">
                  <div class="content-card content-card--no-margin">
                    <div class="flex-container spacing-8 direction-column">
                      <div class="flex-item width-grow">
                        <span
                          class="text text-color--gray900 text-font-size--36 text-font-weight--600"
                          style="line-height: 1"
                        >
                          <!-- ZOOM-873715: minor changes - adding a "data-test-id" for QA TA testing -->
                          <span v-if="amount" data-test-id=“furikomi_amount”>{{ getTotalAmount }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex-item width-grow">
                  <div class="content-card content-card--no-margin">
                    <div class="flex-container spacing-16 direction-column">
                      <div class="flex-item width-grow">
                        <div class="bank-transfer-details flex-container spacing-16 direction-column">
                          <div class="flex-item width-grow">
                            <span class="text text-color--gray800 text-font-size--16 text-font-weight--600">
                              {{ $t('billing.bank_transfer.bank_information') }}
                            </span>
                          </div>
                          <div class="flex-item width-grow">
                            <span class="text text-color--default text-font-size--14">
                              {{ $t('billing.bank_transfer.transfer_funds') }}
                            </span>
                          </div>
                          <div class="flex-item width-grow">
                            <dl class="details-table details-table--copyable">
                              <template v-for="(value, key) in bankTransferDetails" :key="key">
                                <dt class="details-table-label">
                                  <span class="text text-color--gray400 text-font-size--14">
                                    {{ $t(`billing.bank_transfer.${key}`) }}
                                  </span>
                                </dt>
                                <dd class="details-table-value">
                                  <div class="flex-container spacing-8 direction-row">
                                    <div class="details-table-value-text flex-item width-grow">
                                      <span
                                        :ref="key"
                                        class="text text-color--default text-font-size--14 text--tabular-numbers"
                                      >
                                        {{ value }}
                                      </span>
                                    </div>
                                    <div class="details-table-row-copy flex-item width-fixed">
                                      <a data-testid="checkout-a-420" class="link" target="_self" @click="copyToClipboard(key)">
                                        <div class="copy-link-wrapper">
                                          <svg
                                            class="icon clipboard"
                                            focusable="false"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            width="16"
                                          >
                                            <path
                                              d="m7 5h2c1.6568542 0 3-1.34314575 3-3 1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2h-8c-1.1045695 0-2-.8954305-2-2v-10c0-1.1045695.8954305-2 2-2 0 1.65685425 1.34314575 3 3 3zm-1-3c0-1.1045695.8954305-2 2-2s2 .8954305 2 2c0 .55228475-.44771525 1-1 1h-2c-.55228475 0-1-.44771525-1-1z"
                                              fill-rule="evenodd"
                                            ></path>
                                          </svg>
                                          <span class="text text-color--default text-font-size--14"></span>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </dd>
                              </template>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-item width-grow">
              <footer class="stripe-footer footer">
                <div class="footer-powered-by">
                  <a data-testid="checkout-a-421" class="link link--primary" href="https://stripe.com/" target="_blank" rel="noopener">
                    <span class="text text-color--gray400 text-font-size--12 text-font-weight--400">
                      {{ $t('billing.bank_transfer.powered_by') }}
                      <svg
                        class="icon footer-powered-by-icon icon--md"
                        focusable="false"
                        width="33"
                        height="15"
                        role="img"
                        aria-labelledby="stripe-title"
                      >
                        <title id="stripe-title">{{ $t('billing.bank_transfer.stripe') }}</title>
                        <g fill-rule="evenodd">
                          <path
                            d="M32.956 7.925c0-2.313-1.12-4.138-3.261-4.138-2.15 0-3.451 1.825-3.451 4.12 0 2.719 1.535 4.092 3.74 4.092 1.075 0 1.888-.244 2.502-.587V9.605c-.614.307-1.319.497-2.213.497-.876 0-1.653-.307-1.753-1.373h4.418c0-.118.018-.588.018-.804zm-4.463-.859c0-1.02.624-1.445 1.193-1.445.55 0 1.138.424 1.138 1.445h-2.33zM22.756 3.787c-.885 0-1.454.415-1.77.704l-.118-.56H18.88v10.535l2.259-.48.009-2.556c.325.235.804.57 1.6.57 1.616 0 3.089-1.302 3.089-4.166-.01-2.62-1.5-4.047-3.08-4.047zm-.542 6.225c-.533 0-.85-.19-1.066-.425l-.009-3.352c.235-.262.56-.443 1.075-.443.822 0 1.391.922 1.391 2.105 0 1.211-.56 2.115-1.39 2.115zM18.04 2.766V.932l-2.268.479v1.843zM15.772 3.94h2.268v7.905h-2.268zM13.342 4.609l-.144-.669h-1.952v7.906h2.259V6.488c.533-.696 1.436-.57 1.716-.47V3.94c-.289-.108-1.346-.307-1.879.669zM8.825 1.98l-2.205.47-.009 7.236c0 1.337 1.003 2.322 2.34 2.322.741 0 1.283-.135 1.581-.298V9.876c-.289.117-1.716.533-1.716-.804V5.865h1.716V3.94H8.816l.009-1.96zM2.718 6.235c0-.352.289-.488.767-.488.687 0 1.554.208 2.241.578V4.202a5.958 5.958 0 0 0-2.24-.415c-1.835 0-3.054.957-3.054 2.557 0 2.493 3.433 2.096 3.433 3.17 0 .416-.361.552-.867.552-.75 0-1.708-.307-2.467-.723v2.15c.84.362 1.69.515 2.467.515 1.879 0 3.17-.93 3.17-2.548-.008-2.692-3.45-2.213-3.45-3.225z"
                          ></path>
                        </g>
                      </svg>
                    </span>
                  </a>
                </div>
                <div class="footer-links">
                  <a data-testid="checkout-a-422" class="link link--primary" href="https://stripe.com/legal" target="_blank" rel="noopener">
                    <span class="text text-color--gray400 text-font-size--12 text-font-weight--400">
                      {{ $t('billing.bank_transfer.terms') }}
                    </span>
                  </a>
                  <a data-testid="checkout-a-423" class="link link--primary" href="https://stripe.com/privacy" target="_blank" rel="noopener">
                    <span class="text text-color--gray400 text-font-size--12 text-font-weight--400">
                      {{ $t('billing.bank_transfer.privacy') }}
                    </span>
                  </a>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toasts" :class="showToast ? 'show-toast' : ''">
      <div>
        <div class="toast flex-container direction-row align-items-center">
          <svg
            class="icon icon--md icon--white"
            focusable="false"
            fill="white"
            color="white"
            height="16"
            viewBox="0 0 16 16"
            width="16"
          >
            <path
              d="m7 5h2c1.6568542 0 3-1.34314575 3-3 1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2h-8c-1.1045695 0-2-.8954305-2-2v-10c0-1.1045695.8954305-2 2-2 0 1.65685425 1.34314575 3 3 3zm-1-3c0-1.1045695.8954305-2 2-2s2 .8954305 2 2c0 .55228475-.44771525 1-1 1h-2c-.55228475 0-1-.44771525-1-1z"
              fill-rule="evenodd"
            ></path>
          </svg>
          <div class="toast-text flex-item width-auto">
            <span class="text text-color--default" style="color: white">
              {{ $t('billing.bank_transfer.copied_to_clipboard') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apmFundingInstructions } from '@/apis/payment';
import { mapGetters } from 'vuex';
import { JAPANESE_YEN } from '@/common/constants';

export default {
  data() {
    return {
      error: false,
      loading: true,
      copyToClipboardTimeout: null,
      showToast: false,
      currencyCode: JAPANESE_YEN,
      pollingIntervalTimeout: null,
      retryTimes: 0,
      maxRetryTimes: 15,
      pollingIntervalTime: 3000,
      amount: null,
      bankTransferDetails: {
        bank_code: '',
        bank_name: '',
        branch_code: '',
        branch_name: '',
        account_type: '',
        account_number: '',
        account_holder: ''
      }
    };
  },
  async mounted() {
    try {
      await this.pollBankTransferInfoEndpoint()
      this.loading = false
    } catch (e) {
      console.error('unable to get bank transfer instructions: ', e)
      this.$message.error(this.$t('billing.unknown_error'))
      this.error = true
    }
  },
  computed: {
    getTotalAmount() {
      return new Intl.NumberFormat(this.$cookie.get('_zm_lang'), {
        style: 'currency',
        currency: this.currencyCode
      }).format(this.amount);
    },
     ...mapGetters([
      'account',
    ]),
  },
  methods: {
    copyToClipboard(refName) {
      if (this.copyToClipboardTimeout) {
        clearTimeout(this.copyToClipboardTimeout);
      }
      const element = this.$refs[refName] && this.$refs[refName][0]
      let clipboardContent = ''
      if (element?.textContent) {
        clipboardContent = element.textContent
      }
      navigator.clipboard.writeText(clipboardContent)
      this.showToast = true;
      this.copyToClipboardTimeout = setTimeout(() => {
        this.showToast = false;
        this.copyToClipboardTimeout = null;
      }, 2500);
    },
    pollBankTransferInfoEndpoint() {
      return new Promise((resolve, reject) => {
        const pollingInterval = async () => {
          try {
            this.clearTimeOutEvent()
            this.retryTimes++
            const result = await this.getBankTransferInfo()
            if (result) {
              resolve()
            } else {
              this.retryTimes > this.maxRetryTimes
                ? reject('retry limit')
                : (this.pollingIntervalTimeout = setTimeout(pollingInterval, this.pollingIntervalTime))
            }
          } catch (e) {
            reject(typeof e === 'string' ? e : e?.message)
          }
        }
        pollingInterval()
      })
    },
    clearTimeOutEvent() {
      this.pollingIntervalTimeout && clearTimeout(this.pollingIntervalTimeout)
    },
    async getBankTransferInfo() {
      try {
        const email = this.$config('email') || this.account.email;
        const data = await apmFundingInstructions({ email, currencyCode: this.currencyCode });
        const result = data?.result || data?.data?.result;
        if (result.status && result.result) {
          const { bankCode, bankName, branchCode, branchName, accountType, accountNumber, accountHolder, amount } =
            result.result;
          this.bankTransferDetails.bank_code = bankCode
          this.bankTransferDetails.bank_name = bankName
          this.bankTransferDetails.branch_code = branchCode
          this.bankTransferDetails.branch_name = branchName
          this.bankTransferDetails.account_type = accountType
          this.bankTransferDetails.account_number = accountNumber
          this.bankTransferDetails.account_holder = accountHolder
          this.amount = amount
          return true
        }
      } catch (error) {
        console.error('Error fetching bank transfer instructions: ', error)
        return false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@supports (scroll-behavior: smooth) {
  .apm-bank-transfer {
    scroll-behavior: smooth;
  }
}

.apm-bank-transfer {
  -webkit-font-smoothing: antialiased;
  color: hsla(0, 0%, 10%, 0.9);
  font-size: 16px;
  margin: 0 auto;
  padding: 0;
  line-height: 1.3;
  min-height: 600px;
  position: relative;
  max-width: 600px;

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  .app-container {
    align-items: center;
    justify-content: center;
    padding: 0 0 120px 0;
    border: 1px solid rgba(82, 82, 128, 0.18);
    border-radius: 20px;
  }

  .flex-container {
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-item {
    box-sizing: border-box;
    flex: 0 1 auto;
    max-width: 100%;
    min-width: 0;
  }

  .direction-row {
    flex-direction: row;
  }

  .direction-column {
    flex-direction: column;
  }

  .spacing-0 {
    margin: 0;
  }

  .spacing-0 > .flex-item {
    padding: 0;
  }

  .spacing-8 {
    margin: -4px;
  }

  .spacing-8 > .flex-item {
    padding: 4px;
  }

  .spacing-16 {
    margin: -8px;
  }

  .spacing-16 > .flex-item {
    padding: 8px;
  }

  .align-items-center {
    align-items: center;
  }

  .width-auto {
    width: auto;
  }

  .width-fixed {
    flex-basis: auto;
    flex-shrink: 0;
  }

  .width-grow {
    flex-basis: 0;
    flex-grow: 1;
  }

  .text {
    margin: 0;
  }

  .text-font-size--12 {
    font-size: 12px;
  }

  .text-font-size--14 {
    font-size: 14px;
  }

  .text-font-size--16 {
    font-size: 16px;
  }

  .text-font-size--36 {
    font-size: 36px;
  }

  .text-font-weight--400 {
    font-weight: 400;
  }

  .text-font-weight--600 {
    font-weight: 600;
  }

  .text-color--gray400 {
    color: hsla(0, 0%, 10%, 0.5);
  }

  .text-color--gray800 {
    color: hsla(0, 0%, 10%, 0.9);
  }

  .text-color--gray900 {
    color: hsla(0, 0%, 10%, 1);
  }

  .text--tabular-numbers {
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03rem;
  }

  .link {
    cursor: pointer;
    text-decoration: none;
  }

  .link:focus {
    outline: 1px dotted hsla(0, 0%, 10%, 0.5);
  }

  .link--primary {
    color: #0074d4;
  }

  .icon--md {
    height: 16px;
  }

  .icon--white {
    fill: #ffffff;
  }

  .footer {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .footer-powered-by-icon {
    margin-left: 5px;
    fill: hsla(0, 0%, 10%, 0.4);
    transform: translateY(1.5px);
    vertical-align: text-bottom;
  }

  .footer-powered-by {
    text-align: center;
    width: 100%;
  }

  .footer-links,
  .footer-powered-by {
    padding: 4px;
  }

  .footer-links .link {
    margin-right: 12px;
    text-decoration: underline dotted hsla(0, 0%, 10%, 0.5);
  }

  .footer-links .link:last-of-type {
    margin-right: 0;
  }

  @media only screen and (min-width: 992px) {
    .footer {
      flex-direction: row;
      height: 16px;
      line-height: 16px;
    }

    .footer-links {
      padding: 0 0 0 16px;
    }

    .footer-powered-by {
      border-right: 1px solid hsla(0, 0%, 10%, 0.1);
      padding: 0 16px 0 0;
      text-align: left;
      width: auto;
    }
  }

  .stripe-footer {
    justify-content: center;
  }

  .stripe-footer {
    margin-top: 0;
  }

  .content-card {
    background-color: #ffffff;
    border-radius: 6px;
    box-shadow: 0 0 0 1px rgba(175, 175, 175, 0.2), 0 15px 35px 0 rgba(49, 49, 93, 0.08),
      0 5px 15px 0 rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
    padding: 32px;
    width: 100%;
  }

  .content-card.content-card--no-margin {
    margin-bottom: 0;
  }

  @media screen {
    .content-card {
      background-color: transparent;
      box-shadow: none;
      margin-bottom: 0;
      padding: 16px 32px;
    }
  }

  .stripe {
    margin-bottom: 48px;
    margin-left: auto;
    margin-right: auto;
    width: 443px;
  }

  .stripe-footer {
    margin-top: 12px;
  }

  @media screen {
    .stripe {
      margin: 48px 0 0;
      width: auto;
    }
  }

  .clipboard {
    margin-right: 4px;
  }

  .copy-link-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    fill: hsla(0, 0%, 10%, 0.5);
    color: hsla(0, 0%, 10%, 0.5);
  }

  .copy-link-wrapper:hover {
    fill: hsla(0, 0%, 10%, 0.7);
    color: hsla(0, 0%, 10%, 0.7);
  }

  .copy-link-wrapper:active {
    fill: hsla(0, 0%, 10%, 1);
    color: hsla(0, 0%, 10%, 1);
  }

  .copy-link-wrapper > .clipboard {
    fill: inherit;
    color: inherit;
  }

  .toast {
    background-color: #3c4257;
    border-radius: 6px;
    box-shadow: 0 7px 14px 0 rgba(60, 66, 87, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.12);
    padding: 12px 16px;
    pointer-events: all;
  }

  .toast * + .toast-text {
    margin-left: 8px;
  }

  .toast + .toast {
    margin-top: 12px;
  }

  .toasts {
    align-items: center;
    flex-direction: column;
    pointer-events: none;
    margin-top: -80px;
    visibility: hidden;
    opacity: 0;
    transition: opacity 250ms ease, visibility 250ms ease;
  }

  .toasts.show-toast {
    visibility: visible;
    opacity: 1;
  }

  .details-table,
  .toasts {
    display: flex;
  }

  .details-table {
    background-color: #f7f7f7;
    border: 1px solid hsla(0, 0%, 10%, 0.1);
    border-radius: 6px;
    flex-flow: row wrap;
    margin: 0;
    padding: 10px 20px;
  }

  .details-table--copyable {
    padding: 20px;
  }

  .details-table-label,
  .details-table-value {
    -ms-flex-preferred-size: 50%;
    -webkit-flex-basis: 50%;
    flex-basis: 50%;
    margin: 4px 0 0;
  }

  .details-table-label:first-of-type,
  .details-table-value:first-of-type {
    margin-top: 0;
  }

  .details-table-value-text {
  }

  .details-table-row-copy {
    box-sizing: content-box;
  }

  .details-table-row-copy .clipboard {
    margin-right: 0;
  }

  .bank-transfer-details .details-table-label {
    flex-basis: 45%;
  }

  .bank-transfer-details .details-table-value {
    flex-basis: 55%;
  }

  .circular {
    position: relative;
    top: 150px;
    left: 50%;
    height: auto;
    width: 42px;
    margin-top: -21px;
    margin-left: -21px;
    animation: loading-rotate 2s linear infinite;
  }

  .path {
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90, 150;
    stroke-dashoffset: 0;
    stroke-width: 2;
    stroke: #0e71eb;
    stroke-linecap: round;
  }

  @keyframes loading-rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120px;
    }
  }
}
</style>
